import { render } from "./Contact.vue?vue&type=template&id=dd8d307e"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=dd8d307e&lang=css"
script.render = render

export default script